'use strict';

const Listing = {
    init: function (resize) {
        Listing.resize = resize;
        const allListing = document.querySelectorAll('.c-listing[data-api]');
        if (allListing) {
            allListing.forEach(listingElt => {
                new ListingInstance(listingElt);
            });
        }
    },
};

export default Listing;

class ListingInstance {
    constructor(block) {
        this.block = block;
        this.api = block.dataset.api;
        this.contentCtn = block.querySelector('.c-listing__content:not(.c-listing__sticky)');
        this.loader = block.querySelector('.c-loader');
        this.loadMoreBtn = block.querySelector('.c-listing__loadmore');
        this.filters = {};
        this.currentPage = 1;
        this.renderedCount = 0;
        this.totalPages = parseInt(block.dataset.totalpages, 10) || 1;
        this.hasMoreResults = this.currentPage <= this.totalPages;

        if (this.api) {
            this.initFilters();
            this.events();
        } else {
            console.error('API URL not found for block:', block);
        }
    }

    initFilters() {
        const filterElements = this.block.querySelectorAll('.js-select');
        filterElements.forEach(filter => {
            this.filters[filter.name] = [filter.value];
        });
    }
    handleFilterChange(filter) {
        if (!this.filters[filter.name]) {
            this.filters[filter.name] = [];
        }
        this.filters[filter.name] = [filter.value];

        // Filtre ds la liste sticky
        const stickyContainer = document.querySelector('.c-listing__sticky');
        if (stickyContainer) {
            const stickyItems = document.querySelectorAll('.c-listing__sticky li[data-locations]');
            stickyItems.forEach(li => {
                const location = li.dataset.locations;
                if (filter.value === "" || location === filter.value) {
                    li.classList.remove('hide');
                } else {
                    li.classList.add('hide');
                }
            });
        }
        
        // Réinit
        this.currentPage = 1;
        this.hasMoreResults = true;
        this.contentCtn.innerHTML = "";
        this.fetchApi();
    }

    events() {
        const filterElements = this.block.querySelectorAll('.js-select');
        filterElements.forEach(filter => {
            filter.addEventListener('change', (e) => {
                console.log(filter)
                this.handleFilterChange(filter);
                let parent = e.target.closest(".is-focused");
                if (parent) {
                    parent.classList.remove("is-focused");
                }
            });
        });

        this.loadMoreBtn.querySelector('button').addEventListener('click', () => this.loadMore());
    }

    createListContainer() {
        const ul = document.createElement('ul');
        this.contentCtn.appendChild(ul);
        return ul;
    }

    fetchApi() {
        if (!this.api || this.currentPage > this.totalPages) return;

        this.loader.classList.remove('hide--');
        this.loadMoreBtn.classList.remove('show--');

        const queryParts = [`paged=${this.currentPage}`];
        Object.keys(this.filters).forEach(filterName => {
            this.filters[filterName].forEach(value => {
                if (value !== "") {
                    queryParts.push(`${filterName}[]=${encodeURIComponent(value)}`);
                }
            });
        });

        const queryString = queryParts.join('&');

        fetch(`${this.api}&${queryString}`)
            .then(response => response.json())
            .then(data => {
                if (data.items && data.items.length > 0) {
                    // console.log(data.items)
                    this.renderListing(data.items);
                } else {
                    this.contentCtn.innerHTML = `<p class="c-listing__noresults">${this.block.dataset.noresults || "No results"}</p>`;
                }

                this.totalPages = data.totalPages || this.totalPages;
                this.hasMoreResults = this.currentPage <= this.totalPages;
                this.toggleLoadMoreButton();
            })
            .catch(error => console.error('Error fetching experts:', error))
            .finally(() => {
                this.loader.classList.add('hide--');
            });
    }

    renderListing(list) {
        const ul = this.contentCtn.querySelector('ul') || this.createListContainer();
        list.forEach((item) => {
            const listItem = document.createElement('li');
            
            if(item.author === null){
                item.author = [];
            }

            listItem.innerHTML = `
                <div class="c-card ${this.block.dataset.type || ""}">
                    <a href="${item.permalink || '#'}">
                        ${item.image && item.image.sizes ? `
                            <div class="c-card__img">
                                <div role="figure" class="figure" aria-label="${item.image.alt || 'Default description'}">
                                    <picture>
                                        ${item.image.sizes['desktop'] && item.image.sizes['desktop-retina'] ? `
                                            <source media="(min-width: 1320px)" srcset="${item.image.sizes['desktop']} 1x, ${item.image.sizes['desktop-retina']} 2x">
                                            <source media="(min-width: 840px)" srcset="${item.image.sizes['desktop']} 1x, ${item.image.sizes['desktop-retina']} 2x">
                                        ` : ''}
                                        ${item.image.sizes['mobile'] && item.image.sizes['mobile-retina'] ? `
                                            <source media="(min-width: 200px)" srcset="${item.image.sizes['mobile']} 1x, ${item.image.sizes['mobile-retina']} 2x">
                                        ` : ''}
                                        <img loading="lazy"  src="${item.image.sizes['mobile-retina'] || item.image.sizes['desktop']}" alt="${item.image.alt || ''}"  width="${item.image.sizes['mobile-retina-width'] || "300"}" height="${item.image.sizes['mobile-retina-height'] || "300"}" />
                                    </picture>
                                </div>
                                <div class="c-card__img-link">
                                    <i class="icon-arrow-light" aria-hidden="true"></i>
                                </div>
                            </div>`
                        : ''}
                        <div class="c-card__content">
                            ${item.date ?
                                `<div class="c-card__category">
                                    ${item.capability && Object.keys(item.capability).length > 0 ?
                                        `<span class="darkBlue">${Object.values(item.capability).join('<span class="blue sep"> | </span>')}</span>`
                                    : ''}
                                    <span class="class="c-card__category">${item.date}</span>
                                </div>`
                            : ''
                            }

                            ${item.title ? `<h2 class="h6 fontMedium c-card__title">${item.title}</h2>` : ''}
                            ${(item.job_title || item.agency || item.location) ? `
                                <div class="c-card__category">
                                    ${item.job_title || ''} ${(item.job_title && item.location && Object.keys(item.location).length > 0) ? ' <span class="sep">|</span> ' : ''} 
                                    ${item.location && Object.keys(item.location).length > 0 ? ` ${Object.values(item.location).join(' <span class="sep">|</span> ')}` : ''}
                                </div>
                            ` : ''}
                            ${item.expertise && Object.keys(item.expertise).length > 0 ? `
                                <div class="c-card__expertise">
                                    <span>Expertise:</span> ${Object.values(item.expertise).join(', ')}
                                </div>
                            ` : ''}
                            ${item.excerpt ? `
                                <div class="c-card__desc">
                                    ${item.excerpt}
                                </div>
                            ` : ''}
                            
                        </div>
                    </a>
                    ${item.author ? `
                        <div class="c-card__authorBox">
                            ${item.author.map(author => 
                                `<div class="c-card__author">
                                    ${author.image ?
                                        `<div role="figure" class="figure" aria-label="${author.image.alt}">
                                            <picture>
                                                <source media="(min-width: 1320px)" srcset="${author.image.sizes['desktop']} 1x, ${author.image.sizes['desktop-retina']} 2x">
                                                <source media="(min-width: 840px)" srcset="${author.image.sizes['desktop']} 1x, ${author.image.sizes['desktop-retina']} 2x">
                                                <source media="(min-width: 200px)" srcset="${author.image.sizes['mobile']} 1x, ${author.image.sizes['mobile']} 2x">
                                                <img loading="lazy" src="${author.image.sizes['mobile']}" alt="${author.image.alt}" width="${author.image.sizes['mobile-width']}" height="${author.image.sizes['mobile-height']}">
                                            </picture>
                                        </div>`
                                    : ''}
                                    ${author.name}
                                </div>`
                            ).join("")}
                        </div>`
                    : '' }
                    ${item.expert ? `
                        <div class="c-card__authorBox">
                            ${item.expert.map(expert => 
                                `<a href="${expert.link}" class="c-card__author">
                                    ${expert.image ?
                                        `<div role="figure" class="figure" aria-label="${expert.image.alt}">
                                            <picture>
                                                <source media="(min-width: 1320px)" srcset="${expert.image.sizes['desktop']} 1x, ${expert.image.sizes['desktop-retina']} 2x">
                                                <source media="(min-width: 840px)" srcset="${expert.image.sizes['desktop']} 1x, ${expert.image.sizes['desktop-retina']} 2x">
                                                <source media="(min-width: 200px)" srcset="${expert.image.sizes['mobile']} 1x, ${expert.image.sizes['mobile']} 2x">
                                                <img loading="lazy" src="${expert.image.sizes['mobile']}" alt="${expert.image.alt}" width="${expert.image.sizes['mobile-width']}" height="${expert.image.sizes['mobile-height']}">
                                            </picture>
                                        </div>`
                                    : ''}
                                    ${expert.name}
                                </a>`
                            ).join("")}
                        </div>`
                    : '' }
                </div>
                
            `;
            ul.appendChild(listItem);
        });

        Listing.resize();
    }

    toggleLoadMoreButton() {
        if (this.currentPage < this.totalPages) {
            this.loadMoreBtn.classList.add('show--');
        } else {
            this.loadMoreBtn.classList.remove('show--');
        }
    }
    loadMore() {
        if (this.currentPage < this.totalPages) {
            this.currentPage++;
            this.fetchApi();
        }
    }
}

